import { useMemo } from 'react';
import { getAvailableDomains, getAccessibleDomains } from '@/domain-registry';
import { useAuthUnified } from '@/hooks/shared/useAuthUnified';

/**
 * Get non-hidden domains the user can access.
 * Used by the homepage domain sidebar.
 */
export function useAvailableDomains() {
  const { groupAccess } = useAuthUnified();

  return useMemo(
    () => getAvailableDomains(),
    [groupAccess]
  );
}

/**
 * Get all domains the user can access, including hidden ones.
 * Used by the domain switcher dropdown.
 */
export function useAccessibleDomains() {
  const { groupAccess } = useAuthUnified();

  return useMemo(
    () => getAccessibleDomains(),
    [groupAccess]
  );
}